import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-loading-space-delete',
    templateUrl: './loading-space-delete.component.html',
    styleUrls: ['./loading-space-delete.component.scss'],
    standalone: false
})
export class LoadingSpaceDeleteComponent implements OnInit {
  public form: UntypedFormGroup;
  constructor(private modalRef: ModalOverlayRef, private cookieService: CookieService) {
    this.modalRef.backgroundClicked();
  }

  public ngOnInit() {
    this.form = new UntypedFormGroup({
      dontShowAgain: new UntypedFormControl(),
    });
  }

  public close(result: boolean) {
    if (result && this.form.get('dontShowAgain').value) {
      this.cookieService.set(
        'DELETE_OVERLAP_POPUP',
        this.form.get('dontShowAgain').value,
        undefined,
        '/',
        null,
        false,
        'Lax',
      );
    }
    this.modalRef.close(result);
  }
}
